<template>
  <div class="container mx-auto px-4 sm:px-8 max-w-max">
    <div class="p-0">
      <div class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
        <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">
          <table class="min-w-full leading-normal">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="px-5 py-3 bg-slate-50 border-b border-gray-200 text-gray-800 text-left text-lg font-semibold uppercase font-normal"
                >
                  US High School Sports News Feed
                </th>
              </tr>
            </thead>
            <tbody>
              <div
                v-for="post in posts"
                :key="post.url"
                class="hover:bg-gray-50 border-b border-gray-200 bg-white"
              >
                <tr>
                  <td class="px-5 py-5 text-base">
                    <div class="flex items-center">
                      <div class="flex-shrink-0">
                        <a href="#" class="block relative">
                          <img
                            alt="profile"
                            v-bind:src="post.img"
                            class="mx-auto object-cover h-10 w-10 rounded-lg"
                          />
                        </a>
                      </div>
                      <div class="ml-3">
                        <a v-bind:href="post.url" target="_blank">
                          <p
                            class="text-gray-900 whitespace-pre text-base font-medium truncate"
                          >
                            {{ post.title }}
                          </p>
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
              </div>
            </tbody>
          </table>
          <div
            class="px-5 bg-white py-5 flex flex-col xs:flex-row items-center xs:justify-between"
          >
            <div class="flex items-center">
              <button
                type="button"
                class="w-full p-4 border text-base rounded-l-xl text-gray-600 bg-white hover:bg-gray-100"
                @click="getOldPosts2"
              >
                <svg
                  width="15"
                  fill="currentColor"
                  height="15"
                  class=""
                  viewBox="0 0 1792 1792"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1427 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z"
                  ></path>
                </svg>
              </button>

              <button
                type="button"
                class="w-full p-4 border-t border-b border-r text-base rounded-r-xl text-gray-600 bg-white hover:bg-gray-100"
                @click="getOldPosts"
              >
                <svg
                  width="15"
                  fill="currentColor"
                  height="15"
                  class=""
                  viewBox="0 0 1792 1792"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1363 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45l166-166q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "HelloWorld",
  data() {
    return { posts: [], counter: 2 };
  },
  created() {
    this.getLatestPosts();
  },
  methods: {
    getLatestPosts() {
      axios
        .get("https://sports-news-feed.akul3007.repl.co/latest")
        .then((response) => {
          this.posts = response.data.data;
        });
    },
    getOldPosts() {
      this.counter = this.counter + 1;
      if (this.counter == 13) {
        this.counter = this.counter + 1;
      }

      axios
        .get("https://sports-news-feed.akul3007.repl.co/old/" + this.counter)
        .then((response) => {
          this.posts = response.data.data;
        });
    },
    getOldPosts2() {
      this.counter = this.counter - 1;
      if (this.counter == 13) {
        this.counter = this.counter - 1;
      }

      if (this.counter <= 1) {
        this.counter = 2;
      }

      axios
        .get("https://sports-news-feed.akul3007.repl.co/old/" + this.counter)
        .then((response) => {
          this.posts = response.data.data;
        });
    },
  },

  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
